// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("/src/assets/decal.png", import.meta.url);
// Module
var code = `<section class="intro"
    id="intro">
    <div class="intro__container container container--space text-center">
        <div class="intro__content"
            ng-bind-html="\$ctrl.introData.description">

        </div>

        <!-- <div class="intro__actions">
            <a ng-href="{{\$ctrl.introData.link}}"
                class="intro__link link-global link-global--purple link-global--semi-block">{{\$ctrl.introData.link}}
                <img src="../../assets/arrow-right.svg"
                    alt="">
            </a>
        </div> -->
    </div>
    <img class="intro__decal d-none d-xl-block"
        src="${___HTML_LOADER_IMPORT_0___}"
        alt="token">
</section>`;
// Exports
export default code;